import type { ReactNode } from "react";
import { memo } from "react";

import AppAuthorize from "../../../../components/AppAuthorize";

import MenuItemHeader from "./MenuItemHeader";

import type App from "byzantine/src/App";

interface SidebarTopLevelNAFItemProps {
  nafApp: App;
  title?: string;
  icon?: string;
  isActive?: boolean;
}

const renderButton = (handleClick: () => void, children: ReactNode) => (
  <button
    type="button"
    className="button--reset"
    style={{ width: "100%" }}
    onClick={handleClick}
    tabIndex={0}
    role="menuitem"
  >
    {children}
  </button>
);

const SidebarTopLevelNAFItem = memo(function SidebarTopLevelNAFItem({
  nafApp,
  title,
  icon,
  isActive,
}: SidebarTopLevelNAFItemProps) {
  return (
    <AppAuthorize app={nafApp} renderButton={renderButton}>
      <MenuItemHeader
        title={title}
        icon={icon}
        route={undefined}
        isOpen={undefined}
        onUserToggle={undefined}
        isActive={isActive}
      />
    </AppAuthorize>
  );
});

export default SidebarTopLevelNAFItem;
